<template>
  <SectionContainer class="fluid-x">
    <SectionHeader>
      <b slot="title">Veja também</b>
      <span slot="subtitle">Dicas exclusivas de alta relevância para quem quer crescer</span>
    </SectionHeader>

    <LoadingContainer v-if="isLoading" class="box--mini" />

    <GenericCarousel
      v-else-if="posts.length"
      options="horizontal"
    >
      <BlogPostItem
        v-for="post in posts"
        :key="post.url"
        :post="post"
      />
    </GenericCarousel>
  </SectionContainer>
</template>

<script>
import { getBlogPosts } from '@/api/blog.api'
import SectionContainer from "@/components/layout/SectionContainer"
import SectionHeader from "@/components/layout/SectionHeader"
import GenericCarousel from "@/components/carousel/GenericCarousel"
import BlogPostItem from "@/components/blog-post/BlogPostItem"
import LoadingContainer from "@/components/layout/LoadingContainer"

export default {
  components: {
    SectionContainer,
    SectionHeader,
    GenericCarousel,
    BlogPostItem,
    LoadingContainer,
  },

  async mounted () {
    this.isLoading = true

    this.posts = await getBlogPosts()

    this.isLoading = false
  },

  data: () => ({
    isLoading: false,
    posts: []
  }),
};
</script>

<style lang="scss" scoped>
.container {
  a.link {
    color: #f39c12;
    font-size: 1.5rem;
  }
}
</style>
